import React from 'react';
import MagicForm from '../../../../../Components/Form/MagicForm';
import { ItemScheme } from '../../../../../Components/Form/MagicFormItem';
import { MagicField } from '../../../../../Enums/MagicField.enum';

export interface IPLPTemplateFormValues {
	name: string;
	manual?: string;
	dosage?: string;
}

interface Props {
	onSubmit: (values: IPLPTemplateFormValues) => void;
	defaultValues?: IPLPTemplateFormValues;
}

const FORM_SCHEME: ItemScheme[] = [
	{
		key: 'name',
		title: 'component.IPLPTemplateForm.name',
		type: MagicField.TEXT_FIELD,
		settings: {
			required: true,
		},
	},
	{
		key: 'manual',
		title: 'component.IPLPTemplateForm.manual',
		type: MagicField.TEXTAREA,
	},
	{
		key: 'dosage',
		title: 'component.IPLPTemplateForm.dosage',
		type: MagicField.TEXT_FIELD,
	},
];

const IPLPTemplateForm: React.FC<Props> = ({ onSubmit, defaultValues }) => {
	return (
		<MagicForm
			formScheme={FORM_SCHEME}
			onSubmit={onSubmit}
			defaultValues={defaultValues}
		/>
	);
};

export default IPLPTemplateForm;
